module.exports = __webpack_public_path__ + "static/img/egg-modal-bg.a1746fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smashing-golden-eggs/egg-modal-bg.png
// module id = NEhk
// module chunks = 215